import * as types from "./actionTypes";

export const fetchPermissionsRequest = () => ({
  type: types.FETCH_PERMISSIONS_REQUEST,
});

export const fetchPermissionsSuccess = (data) => ({
  type: types.FETCH_PERMISSIONS_SUCCESS,
  payload: data,
});

export const fetchPermissionsFailure = () => ({
  type: types.FETCH_PERMISSIONS_FAILURE,
});
